import { render, staticRenderFns } from "./InvestmentsByDays.vue?vue&type=template&id=5008dc7a&"
import script from "./InvestmentsByDays.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsByDays.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentsByDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports